(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ModelloDetailController', ModelloDetailController);

    ModelloDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Modello', 'Struttura'];

    function ModelloDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Modello, Struttura) {
        var vm = this;

        vm.modello = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('ordiniApp:modelloUpdate', function(event, result) {
            vm.modello = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
